import { useSearchParams, useNavigate } from "react-router-dom";
import { Alert, Button, Container, Divider, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PaymentsIcon from "@mui/icons-material/Payments";

import { Balance } from "../common/Balance";
import { useNoticeContext } from "../../context/NoticeContext";
import CustomAxios from "../../utils/CustomAxios";

export const TopupPayment = ({
  issuerId,
  issuerName,
  issuerType,
  selectRate,
  qrType,
}: {
  issuerId: string;
  issuerName: string;
  issuerType: string;
  selectRate?: number;
  qrType?: string;
}) => {
  const navigate = useNavigate();
  const { notice, setNotice, severity, setSeverity } = useNoticeContext();

  // クエリパラメータを取得
  const [searchParams] = useSearchParams();
  const number = searchParams.get("number");
  const solt = searchParams.get("solt");

  const handleTopUpClick = () => {
    if (qrType === "paper") {
      navigate("/manual-topup", { state: { type: "topup" } });
    } else {
      sendQrRequest("topup");
    }
  };

  const handlePaymentClick = () => {
    if (qrType === "paper") {
      navigate("/scan", {
        state: {
          isPaperQr: true,
          issuerName: issuerName,
          issuerId: issuerId,
          issuerType: issuerType,
          selectRate: selectRate,
        },
      });
    } else {
      sendQrRequest("payment");
    }
  };

  const sendQrRequest = (type: "topup" | "payment") => {
    CustomAxios.post(`/issuer/${issuerId}/qr_request`, {
      number: number,
      solt: solt,
      type: type,
    })
      .then(() =>
        navigate("/scan", {
          state: {
            isTopup: type === "topup",
            isFromAlwaysQr: true,
            issuerName: issuerName,
            issuerId: issuerId,
            issuerType: issuerType,
            number: number,
            solt: solt,
          },
        })
      )
      .catch(() => {
        setNotice("店頭QRコードを再度スキャンしてください。");
        setSeverity("error");
      });
  };

  return (
    <>
      {((number && solt) || qrType === "paper") && (
        <>
          <Divider sx={{ my: 2, mx: "auto", width: "80%" }} />
          {notice && (
            <Alert
              severity={severity}
              onClose={() => setNotice(null)}
              sx={{ width: "80%", mx: "auto", my: "30px" }}
            >
              {notice}
            </Alert>
          )}
          <Container
            sx={{
              mt: 4,
              mb: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Balance type="ecoPay" />
            <Button
              variant="outlined"
              sx={{
                mx: "auto",
                my: 2,
                py: 2,
                width: "280px",
                height: "80px",
                justifyContent: "left",
              }}
              onClick={handleTopUpClick}
            >
              <AddCircleOutlineIcon fontSize="large" />
              <Typography sx={{ fontWeight: "bold", ml: 1.5 }}>
                このお店で現金チャージ
              </Typography>
            </Button>
            <Button
              variant="contained"
              sx={{
                mx: "auto",
                mb: 2,
                py: 2,
                width: "280px",
                height: "80px",
                justifyContent: "left",
              }}
              onClick={handlePaymentClick}
            >
              <PaymentsIcon fontSize="large" />
              <Typography sx={{ fontWeight: "bold", ml: 1.5 }}>
                このお店でお支払い
              </Typography>
            </Button>
          </Container>
        </>
      )}
    </>
  );
};
